import { NotificationsList } from 'entities/notifications/notification-list';
import {  useMemo } from 'react';
import { Heading } from 'shared/ui/list-page-heading';
import { useTitleHook } from 'hooks/page-title.hook';
import {  Stack } from '@mui/material';
import {  useNotifications } from 'entities/notifications/notifications.hook';
import { NotificationsFilter } from 'features/notifications/notifications-filter';
import { useSearchParams } from 'react-router-dom';
import { usePagingParams } from 'shared/hooks/paging-params';
import { useActionCreators } from 'shared/store';
import { workShiftReminderActions } from 'entities/salary/work-shifts/work-shift-reminder.slice';
import { parseReminderNotificationDate } from 'features/salary/work-shifts/work-shift-reminder.utils';
import { NotificationDto } from '@sr/dto';



export const NotificationsPage = () => {
  useTitleHook('Уведомления');

  const [searchParams] = useSearchParams();
  const [paging, setPaging] = usePagingParams();
  const searchParamsString = useMemo(() => searchParams.toString(), [searchParams]);
  const { items, isLoading, totalItemsCount } = useNotifications(searchParamsString);
  const { openReminder } = useActionCreators(workShiftReminderActions);

  const handleNotificationClick = (notification: NotificationDto) => {
    const reminderDate = parseReminderNotificationDate(notification.message);
    if (!reminderDate) return;
    openReminder(reminderDate);
  };

  return (<Stack direction='column'>
    <Heading title="Уведомления" />
    <NotificationsFilter />
    <NotificationsList
      items={items}
      isLoading={isLoading}
      totalItemsCount={totalItemsCount}
      pagingData={paging}
      onChangePaging={setPaging}
      onNotificationClick={handleNotificationClick}
    />
  </Stack>);
};
